import { NessoLogo } from '@nesso/ui/icons/nesso-logo';
import { GoogleIcon } from '@nesso/ui/icons/simple-icons-google';
import { Button } from '@nesso/ui/primitives/button';
import { Card } from '@nesso/ui/primitives/card';

import { getApiUrl } from '@/shared/api/get-api-url';

type Props = {
    returnUrl?: string;
};

function getSignInHref(returnUrl?: string): string {
    if (!returnUrl) return getApiUrl('/auth/sign-in');
    return `${getApiUrl('/auth/sign-in')}?returnUrl=${encodeURIComponent(returnUrl)}`;
}

export function SignInPage({ returnUrl }: Props) {
    return (
        <div className="bg-background flex min-h-dvh flex-col items-center justify-center gap-8 px-4">
            <NessoLogo role="img" aria-label="Nesso" />
            <Card className="w-full max-w-sm px-6 py-8 sm:px-10 sm:py-10">
                <div className="flex flex-col items-center gap-6 text-center">
                    <div className="flex flex-col gap-2">
                        <h1 className="text-2xl font-semibold">Admin sign in</h1>
                        <p className="text-muted-foreground text-sm">
                            Sign in with your Nesso Google account to continue.
                        </p>
                    </div>
                    {/* Full browser navigation, not a fetch or router navigate: this starts an
                        OAuth redirect chain that ends on a different origin. */}
                    <Button asChild variant="outline" size="lg" className="w-full">
                        <a href={getSignInHref(returnUrl)}>
                            <GoogleIcon size={20} />
                            Sign in with Google
                        </a>
                    </Button>
                </div>
            </Card>
        </div>
    );
}
